module.exports = __webpack_public_path__ + "img/IronLimbs.39ce5fd9.png";